import { range, interpolateHsl } from 'd3'

const mainColor = '#0047BB' // blue
const highlightColor = '#2DCCD3' // teal
const otherColor = '#F3F3F3' // smoke

const volumeBarColor = '#BDC2C6' // 40% gray
const positiveBarColor = '#0FACE7'  //sky
const negativeBarColor = '#DEE1E2' // 20% gray

const qualitativeColors = [
  '#050139', // Navy
  '#0DCCD3', // Teal
  '#0047BB', // Blue
  '#DECA2B', // Gold
  '#5060F6', // Iris
  '#5B6770', // Gray
  '#0FACE7', // Sky
  '#ACBCC9', // Silver
  '#F44821', // Orange
  '#696788' // 40% Light Navy
]
const timelineColors = [mainColor].concat(qualitativeColors)

const divergingColors = range(0, 16 / 15, 1 / 15)
  .map(interpolateHsl('#00A9E0', '#005500')) // interpolation of 12 blue Grays

export {
  qualitativeColors, timelineColors, divergingColors, otherColor,
  mainColor, highlightColor, volumeBarColor, positiveBarColor, negativeBarColor
}


// WEBPACK FOOTER //
// ./src/pallette.js